import React, { useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'

import Spinner from '../../App/Components/Spinner/Spinner'
import { useAppDispatch, useAppSelector } from '../../App/Hooks/reduxHooks'
import SecondaryMenuUpdater from '../../App/SecondaryMenuUpdater'
import { getUsers } from '../../User/Store/actions'

import { AddGeneralAbsencesPage } from './AddGeneralAbsences.page'
import { EditGeneralAbsencePage } from './EditGeneralAbsence.page'
import { GeneralAbsenceOverViewPage } from './GeneralAbsenceOverView.page'
import { HolidayOverview } from '../Absence/Holiday/HolidayOverview'

export const GeneralAbsenceBootstrap = () => {
  const users = useAppSelector(state => state.users)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (users.list.length === 0 && !users.loading) {
      dispatch(getUsers())
    }
  }, [])

  useEffect(() => {
    SecondaryMenuUpdater.setActive('general-absences')
  }, [])

  if (users === null) {
    return <Spinner />
  }

  return (
    <Switch>
      <Route
        path="/hr/general-absences/edit/:generalAbsenceUuid?"
        component={EditGeneralAbsencePage}
      />
      <Route
        path="/hr/general-absences/add"
        component={AddGeneralAbsencesPage}
      />
      <Route
        path="/hr/general-absences"
        component={GeneralAbsenceOverViewPage}
        exact
      />
      <Route
        path="/hr/general-absences/holidays"
        component={HolidayOverview}
        exact
      />
    </Switch>
  )
}
